module.exports = __webpack_public_path__ + "static/media/fondo-nuevo-home-vuelos.10cf2dc0.webp";